import React, { useEffect, useState } from "react";
import { Share2 } from "lucide-react";
import Card from "../../../user/components/Card";
import ShareModal from "../../components/ShareModal";
import { getStreamProducts, getStreamDetails } from "../../services/stream.service.js";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { SOCKET_CLIENT } from "../../../../utils/socket";
import { SOCKET_EVENTS } from "../../../../utils/Constants";
import { isUserLoggedIn, showLoginRequiredModal, getSellerProfileUrl } from "../../../../utils/commonfunction";
import LiveStreamDetail from "./Detail";

function StreamDetails() {
  const { t } = useTranslation();
  const { id } = useParams(); // stream_id from URL
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const [stream, setStream] = useState(null);
  const [products, setProducts] = useState([]);
  const [totalViewers, setTotalViewers] = useState(0);
  const [totalLikes, setTotalLikes] = useState(0);
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const navigate = useNavigate();
  console.log(stream, "ds121212");
function getUniqueAuthorCount(stream) {
  if (
    !stream ||
    !stream.twitch ||
    !stream.twitch.comments ||
    stream.twitch.comments.length === 0
  ) {
    return 0;
  }

  const comments = stream.twitch.comments;

  const uniqueAuthors = {};

  for (let i = 0; i < comments.length; i++) {
    const author = comments[i].author;

    // mark author as seen
    if (!uniqueAuthors[author]) {
      uniqueAuthors[author] = true;
    }
  }

  // count keys manually (no Object.keys shortcut)
  let count = 0;
  for (let key in uniqueAuthors) {
    count++;
  }

  return count;
}
const count = getUniqueAuthorCount(stream);
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const [streamRes, productRes] = await Promise.all([
          getStreamDetails(id),
          getStreamProducts({ stream_id: id }),
        ]);

        if (streamRes.success) {
          setStream(streamRes?.data);
          setTotalViewers(streamRes?.data?.listOfViewers?.length || 0);
          setTotalLikes(streamRes?.data?.listOfLikedUsers?.length || 0);
          console.log(streamRes, "streamRes");

        }

        if (productRes.success) {
          setProducts(productRes.data || []);
        }

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    const handleViewerCount = (data) => {
      console.log("STREAM_VIEWER_COUNT received:", data);
      setTotalViewers(data?.totalDbViews !== undefined ? data.totalDbViews : data?.totalViewers);
      setTotalLikes(data?.totalLikes);
    };

    const handleLikeUpdate = (data) => {
      setTotalLikes(data?.totalLikes);
    };

    const joinRooms = () => {
      SOCKET_CLIENT.emit("join_stream_room", id);
      SOCKET_CLIENT.emit(SOCKET_EVENTS.JOIN_STREAM, {
        streamID: id,
        userId: "user_details_view", // generic
        role: "advertiser", // Use advertiser role to join socket room without inflating active live viewer count
        isAdvertiser: true
      });
    };

    if (SOCKET_CLIENT.connected) joinRooms();
    SOCKET_CLIENT.on("connect", joinRooms);

    SOCKET_CLIENT.on(SOCKET_EVENTS.STREAM_VIEWER_COUNT, handleViewerCount);
    SOCKET_CLIENT.on(SOCKET_EVENTS.STREAM_LIKE_UPDATE, handleLikeUpdate);

    return () => {
      SOCKET_CLIENT.off("connect", joinRooms);
      SOCKET_CLIENT.off(SOCKET_EVENTS.STREAM_VIEWER_COUNT, handleViewerCount);
      SOCKET_CLIENT.off(SOCKET_EVENTS.STREAM_LIKE_UPDATE, handleLikeUpdate);
    };
  }, [id]);
  useEffect(() => {
    console.log("Updated stream:", stream);
  }, [stream]);
  const isPastStream = Boolean(
    stream && (
      stream?.isStreamCompleted === true ||
      stream?.autoStatus === "past" ||
      (!stream?.isLive && stream?.recording_url)
    )
  );

  const handleViewStream = (item) => {
    if (isPastStream && stream?.recording_url) {
      const video = document.querySelector(".live-stream-detail video");
      if (video) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        video.currentTime = 0;
        video.play().catch(() => {});
        return;
      }
    }
    const sellerId = item?.seller_id || item?.seller?._id || (typeof item?.seller === "string" ? item?.seller : undefined);
    navigate(`/user/live-streams/${sellerId}/${item.room_id}/${item._id}`);
  };
  return (
    <>
      <div className="stream-details-bg py-8 md:py-10">
        <div className="container">
          <div className="space-y-6">
            {/* --- Same Dialog Video Player (Auto Plays above first modal only for past streams with recording) --- */}
            {id && isPastStream && stream?.recording_url && (
              <LiveStreamDetail
                publisherID={stream?.seller_id || stream?.seller?._id || (typeof stream?.seller === "string" ? stream?.seller : undefined)}
                roomID={stream?.room_id}
                streamId={id}
                isEmbedded={true}
              />
            )}

            {/* --- Product Showcase Details Section --- */}
            <div className="bg-white p-[15px] md:p-[30px] rounded-[10px] shadow-[0px_2px_24px_0px_rgba(0,0,0,0.05)] border-1 !border-zinc-100">
              {/* Header and View Recording Button */}
              <div className="flex justify-between items-start mb-3 flex-wrap gap-[10px]">
                <div className="flex flex-col gap-[8px]">
                  <h2 className="headings-h2 text-zinc-950">
                    {stream?.title}
                  </h2>

                  <span className="text-[14px]">
                    Store :{" "}
                    {stream?.seller?.store_name ? (
                      <Link
                        to={getSellerProfileUrl(stream?.seller || { _id: stream?.seller_id, store_name: stream?.seller?.store_name })}
                        className="text-[#FF63B5] hover:underline font-semibold transition-colors cursor-pointer"
                      >
                        {stream.seller.store_name}
                      </Link>
                    ) : (
                      "N/A"
                    )}
                  </span>
                  {/* {stream?.category?.title && (
                    <span className="text-[14px] text-zinc-500">
                      Category : {stream.category.title}
                    </span>
                  )} */}
                  {stream?.seller?.businessCategories?.length > 0 && (
                    <span className="text-[14px] text-zinc-500">
                      Business Categories : {stream.seller.businessCategories.join(", ")}
                    </span>
                  )}
                  <p className="body-md text-zinc-500 !p-0 !m-0">
                    {stream?.date
                      ? new Date(stream.date).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,   // 👈 IMPORTANT
                      })
                      : ""}

                  </p>
                  <p className="body-md text-zinc-500 !p-0 !m-0">
                    {t("streams.duration_minutes", { duration: stream?.duration })}
                  </p>
                </div>
                {stream?.isStreamCompleted && (
                  <button disabled={!stream?.recording_url} onClick={() => handleViewStream(stream)} className="btn btn-pri !bg-[#FF63B5] !border-[#FF63B5] disabled:opacity-50 disabled:cursor-not-allowed">
                    {t("streams.rewatch")}
                  </button>
                )}
              </div>

              {/* Engagement Metrics */}
              <div className="flex gap-[15px] flex-wrap">
                {/* Likes */}
                <div className="flex items-center space-x-1 p-2 bg-white border rounded-lg text-gray-700 rounded-full">
                  <img src="/images/heart01.svg" alt="heart" />
                  <span className="text-zinc-950 text-[16px]">{t("streams.likes_count", { count: totalLikes })}</span>
                </div>

                {/* Live Viewers (Example 1) */}
                <div className="flex items-center space-x-1 p-2 bg-white border rounded-lg text-gray-700 rounded-full">
                  <img src="/images/eye01.svg" alt="eye" />
                  <span className="text-zinc-950 text-[16px]">{t("streams.views_count", { count: totalViewers })}</span>
                </div>

                {/* Share */}
                <button
                  type="button"
                  onClick={() => setShowShareModal(true)}
                  className="flex items-center gap-2 px-4 py-2 bg-white border border-zinc-300 hover:border-[var(--secondary-500)] rounded-full text-zinc-800 font-semibold text-[16px] shadow-sm transition-all active:scale-95 hover:bg-zinc-50"
                  title={t("streams.share")}
                >
                  <Share2 className="w-4 h-4 text-[var(--secondary-500)] shrink-0" />
                  <span className="whitespace-nowrap">{t("streams.share")}</span>
                </button>

                {/* Total Leads */}
                {/* <div className="flex items-center space-x-1 p-2 bg-white border rounded-lg text-gray-700 rounded-full">
                  <img src="/images/user01.svg" alt="user" />
                  <span className="text-zinc-950 text-[16px]">{t("streams.leads_count", { count: stream?.totalLeads || 0 })}</span>
                </div> */}
              </div>
            </div>

            {/* --- Social Media Section --- */}
            <div className="p-6 bg-gray-50 rounded-[16px]">
              <h3 className="body-lg text-zinc-500 mb-3">{t("streams.social_media")}</h3>

              <div className="flex flex-wrap gap-[15px]">
                {/* Twitch */}
                <div className="flex items-center gap-[10px] p-2 bg-white border !border-zinc-100 rounded-[10px] text-gray-700 hover:shadow-md transition duration-150">
                  <img className="w-[30px] h-[30px]" src="/images/twitch.png" alt="facebook" />
                  <span className="body-lg text-zinc-500">{t("streams.views_count", { count: stream?.twitchViews ? stream?.twitchViews : count })}</span>
                </div>

                {/* Facebook */}
                <div className="flex items-center gap-[10px] p-2 bg-white border !border-zinc-100 rounded-[10px] text-gray-700 hover:shadow-md transition duration-150">
                  <img src="/images/s-icon02.svg" alt="facebook" />
                  <span className="body-lg text-zinc-500">{t("streams.views_count", { count: stream?.facebookViews })}</span>
                </div>

                {/* YouTube */}
                <div className="flex items-center gap-[10px] p-2 bg-white border !border-zinc-100 rounded-[10px] text-gray-700 hover:shadow-md transition duration-150">
                  <img src="/images/s-icon03.svg" alt="youtube" />
                  <span className="body-lg text-zinc-500">{t("streams.views_count", { count: stream?.youtubeViews })}</span>
                </div>
              </div>

              {/* Comments Section */}
              <div className="mt-6">
                <h3 className="body-lg text-zinc-500 mb-3">{t("streams.social_media_comments")}</h3>
                {(!stream?.facebook?.comments?.length && !stream?.youtube?.comments?.length && !stream?.twitch?.comments?.length) ? (
                    <p className="text-gray-400 text-sm">{t("streams.no_comments_syncing")}</p>
                ) : (
                    <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
                        {/* YouTube Comments */}
                        {stream?.youtube?.comments?.map((comment, index) => (
                            <div key={`yt-${index}`} className="flex items-start gap-3 bg-white p-3 rounded-lg border border-red-100">
                                <img src="/images/s-icon03.svg" alt="youtube" className="w-5 h-5 mt-1" />
                                <div>
                                    <p className="text-sm font-semibold text-zinc-800">{comment.author}</p>
                                    <p className="text-sm text-zinc-600">{comment.text}</p>
                                </div>
                            </div>
                        ))}
                        {/* Facebook Comments */}
                        {stream?.facebook?.comments?.map((comment, index) => (
                            <div key={`fb-${index}`} className="flex items-start gap-3 bg-white p-3 rounded-lg border border-blue-100">
                                <img src="/images/s-icon02.svg" alt="facebook" className="w-5 h-5 mt-1" />
                                <div>
                                    <p className="text-sm font-semibold text-zinc-800">{comment.author}</p>
                                    <p className="text-sm text-zinc-600">{comment.text}</p>
                                </div>
                            </div>
                        ))}
                        {/* Twitch Comments (If any support added later) */}
                        {stream?.twitch?.comments?.map((comment, index) => (
                            <div key={`tw-${index}`} className="flex items-start gap-3 bg-white p-3 rounded-lg border border-purple-100">
                            <img className="w-[25px] h-[25px]" src="/images/twitch.png" alt="facebook" />
                                <div>
                                    <p className="text-sm font-semibold text-zinc-800">{comment.author}</p>
                                    <p className="text-sm text-zinc-600">{comment.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
              </div>
            </div>
          </div>

          <div className="associated-products-bg py-8 pb-0">
            <div className="associated-head mb-3">
              <h2 className="headings-h2 text-zinc-950">{t("streams.associated_products")}</h2>
            </div>

            {loading ? (
              <div className="flex items-center justify-center py-24">
                <div className="w-16 h-16 border-4 border-[#FF63B5] border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : products.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {products?.map((item) => (
                  <div
                    key={item._id}
                    className="cursor-pointer"
                    onClick={() => {
                      const targetUrl = `/user/product-details?o_id=${item?._id}`;
                      if (!isUserLoggedIn()) {
                        showLoginRequiredModal({
                          navigate,
                          redirectUrl: targetUrl,
                        });
                        return;
                      }
                      navigate(targetUrl);
                    }}
                  >
                    <Card
                      key={item._id}
                      images={item?.image}
                      title={item.title}
                      price={item.price}
                      subtitle={item.description}
                    // editDelete
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-10">
                <p className="text-gray-500">
                  {t("streams.no_associated_products")}
                </p>
              </div>
            )}

          </div>
        </div>
      </div>

      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        stream={stream}
        type="stream"
        customTitle={stream?.title || "Stream"}
      />
    </>
  );
}

export default StreamDetails;
